// Extrae un mensaje de error legible (en español) de una respuesta de axios,
// para poder mostrárselo al usuario y que sepa qué ha pasado sin llamar a soporte.
export function apiError(err, fallback = 'Se produjo un error') {
  const resp = err && err.response;

  // Sin respuesta del servidor: problema de red / tiempo de espera.
  if (!resp) {
    if (err && (err.code === 'ECONNABORTED' || /timeout/i.test(err.message || ''))) {
      return 'El servidor tardó demasiado en responder. Inténtalo de nuevo.';
    }
    return 'No hay conexión con el servidor. Revisa tu conexión e inténtalo de nuevo.';
  }

  const status = resp.status;
  const data = resp.data || {};

  // Errores de validación de Laravel (422): mostramos el primero.
  if (data.errors && typeof data.errors === 'object') {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first[0]) return first[0];
  }
  // Mensaje explícito del backend.
  if (typeof data.message === 'string' && data.message && data.message !== 'Server Error') {
    return data.message;
  }

  // Mensajes por código HTTP frecuentes.
  if (status === 413) return 'El archivo es demasiado grande. Reduce su tamaño e inténtalo de nuevo.';
  if (status === 422) return 'Hay datos no válidos. Revisa el formulario.';
  if (status === 401) return 'Tu sesión ha caducado. Vuelve a iniciar sesión.';
  if (status === 403) return 'No tienes permiso para hacer esto.';
  if (status === 404) return 'No se encontró el recurso solicitado.';
  if (status >= 500) return 'Error del servidor. Si persiste, avisa al equipo.';

  return fallback;
}
